const viewport = {
  aspectRatio: null,
  height: null,
  width: null,
};

function setViewport() {
  viewport.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  viewport.width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  viewport.aspectRatio = viewport.width / viewport.height;
}

setViewport();

window.addEventListener('resize', setViewport);

export {viewport};
